import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid";

/**
 * X-DataGrid custom toolbar for tables.
 * Includes buttons for filtering and searching.
 * Uses OR logic between search terms.
 */
export function DataGridToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarQuickFilter
                sx={{ marginLeft: "auto" }}
                quickFilterParser={(searchInput) =>
                    searchInput
                        .split(",")
                        .map((value) => value.trim())
                        .filter((value) => value !== "")
                }
                quickFilterFormatter={(quickFilterValues) => quickFilterValues.join(",")}
            />
        </GridToolbarContainer>
    );
}
